import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink, waLabel, trackWhatsApp } from "@/lib/wa";

/**
 * Único elemento de la página que usa el verde WhatsApp (#25D366).
 * Dispara el evento ClicWhatsApp del píxel de Meta.
 */
export default function WhatsAppButton({
  section,
  label,
  full = false,
  size = "md",
  className = "",
  testId,
  children,
}) {
  const text = label || waLabel(section);
  return (
    <a
      href={waLink(section)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsApp(section)}
      data-testid={testId || `wa-btn-${section}`}
      aria-label={`Escribir por WhatsApp: ${text}`}
      className={`btn-wa ${size === "lg" ? "btn-wa-lg" : ""} ${
        full ? "w-full" : ""
      } ${className}`}
    >
      <MessageCircle size={20} strokeWidth={2} aria-hidden="true" />
      <span>{children || text}</span>
    </a>
  );
}
